<template>
    <div class="page gc">
        <SideMenu />

        <div class="page-content g9">
            <h2>{{ isActives ? "Active" : "Archived" }} Projects</h2>

            <Accord :title="(isActives ? 'Active' : 'Archived') + ' projects'">
                <div class="grid-33w">
                    <ProjectTile :info="project" :key="project.url" v-for="project in projects.filter(x => x.isArchived == !isActives)"></ProjectTile>

                    <div class="tile tile-project tile-project-create" v-if="isActives">
                        <p v-on:click="onNewProjectClick">
                            Create project
                        </p>
                    </div>
                </div>
            </Accord>
        </div>

        <Modal title="Create project" ref="modalNewProject">
            <form v-on:submit="onNewProjectSubmit">
                <div class="input" type="text">
                    <label>
                        <span>Name</span>
                        <input type="text" ref="projectNameInput" placeholder="New project name" v-model="newProjectName"/>
                    </label>
                </div>

                <button class="right edit" v-bind:class="{ 'loading': isLoading }">Create project</button>
            </form>
        </Modal>
    </div>
</template>

<script>
    import API from "../../Api"
    import SideMenu from "../Components/SideMenuProjects.vue"
    import Accord from "../Components/Accord.vue"
    import ProjectTile from "../Components/ProjectTile.vue"
    import Modal from "../Components/Modal.vue"
    import { mapGetters } from 'vuex'

    export default {
        components: {
            SideMenu,
            Accord,
            ProjectTile,
            Modal
        },
        data: () => ({
            newProjectName: null,
            isLoading: false
        }),
        computed: {
            projects(){
                return this.$store.getters.projects()
            },
            isActives(){
                return this.$route.name == "projectsActive"
            }
        },
        methods: {
            onNewProjectClick() {
                this.$refs.modalNewProject.show();
                this.$nextTick(() => this.$refs.projectNameInput.focus())
            },
            onNewProjectSubmit(e) {
                e.preventDefault();

                this.isLoading = true;

                if(this.newProjectName == "")
                {
                    this.isLoading = false;
                    return false;
                }

                var newProject = {
                    title: this.newProjectName,
                    template: ""
                };

                this.$store.dispatch("setProject", newProject).then((res) => {
                    this.$router.push(res.data.url)
                }).catch((res) => {
                    this.isLoading = false;
                })
            }
        }
    }
</script>
